(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3188],{

/***/ 73653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SS": function() { return /* reexport */ queryTypes; },
  "XI": function() { return /* reexport */ useQueryStates; }
});

// UNUSED EXPORTS: useQueryState

;// CONCATENATED MODULE: ../../node_modules/.pnpm/next-usequerystate@1.7.2_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-usequerystate/dist/esm/defs.js
const queryTypes = {
    string: {
        parse: v => v,
        serialize: v => `${v}`,
        withDefault(defaultValue) {
            return Object.assign(Object.assign({}, this), { defaultValue });
        }
    },
    integer: {
        parse: v => parseInt(v),
        serialize: v => Math.round(v).toFixed(),
        withDefault(defaultValue) {
            return Object.assign(Object.assign({}, this), { defaultValue });
        }
    },
    float: {
        parse: v => parseFloat(v),
        serialize: v => v.toString(),
        withDefault(defaultValue) {
            return Object.assign(Object.assign({}, this), { defaultValue });
        }
    },
    boolean: {
        parse: v => v === 'true',
        serialize: v => (Boolean(v) ? 'true' : 'false'),
        withDefault(defaultValue) {
            return Object.assign(Object.assign({}, this), { defaultValue });
        }
    },
    timestamp: {
        parse: v => new Date(parseInt(v)),
        serialize: (v) => v.valueOf().toString(),
        withDefault(defaultValue) {
            return Object.assign(Object.assign({}, this), { defaultValue });
        }
    },
    isoDateTime: {
        parse: v => new Date(v),
        serialize: (v) => v.toISOString(),
        withDefault(defaultValue) {
            return Object.assign(Object.assign({}, this), { defaultValue });
        }
    },
    stringEnum(validValues) {
        return {
            parse: (query) => {
                const asEnum = query;
                if (validValues.includes(asEnum)) {
                    return asEnum;
                }
                return null;
            },
            serialize: (value) => value.toString(),
            withDefault(defaultValue) {
                return Object.assign(Object.assign({}, this), { defaultValue });
            }
        };
    },
    json() {
        return {
            parse: query => {
                try {
                    return JSON.parse(decodeURIComponent(query));
                }
                catch (_a) {
                    return null;
                }
            },
            serialize: value => encodeURIComponent(JSON.stringify(value)),
            withDefault(defaultValue) {
                return Object.assign(Object.assign({}, this), { defaultValue });
            }
        };
    },
    array(itemSerializers, separator = ',') {
        return {
            parse: query => {
                return query
                    .split(separator)
                    .map(item => decodeURIComponent(item))
                    .map(itemSerializers.parse)
                    .filter(value => value !== null && value !== undefined);
            },
            serialize: values => values
                .map(value => {
                if (itemSerializers.serialize) {
                    return itemSerializers.serialize(value);
                }
                return `${value}`;
            })
                .map(encodeURIComponent)
                .join(separator),
            withDefault(defaultValue) {
                return Object.assign(Object.assign({}, this), { defaultValue });
            }
        };
    }
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/router.js
var next_router = __webpack_require__(51516);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/next-usequerystate@1.7.2_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-usequerystate/dist/esm/useQueryState.js


/**
 * React state hook synchronized with a URL query string in Next.js
 *
 * If used without a `defaultValue` supplied in the options, and the query is
 * missing in the URL, the state will be `null`.
 *
 * ### Behaviour with default values:
 *
 * _Note: the URL will **not** be updated with the default value if the query
 * is missing._
 *
 * Setting the value to `null` will clear the query in the URL, and return
 * the default value as state.
 *
 * Example usage:
 * ```ts
 *   // Blog posts filtering by tag
 *   const [tag, selectTag] = useQueryState('tag')
 *   const filteredPosts = posts.filter(post => tag ? post.tag === tag : true)
 *   const clearTag = () => selectTag(null)
 *
 *   // With default values
 *
 *   const [count, setCount] = useQueryState(
 *     'count',
 *     queryTypes.integer.defaultValue(0)
 *   )
 *
 *   const increment = () => setCount(oldCount => oldCount + 1)
 *   const decrement = () => setCount(oldCount => oldCount - 1)
 *   const clearCountQuery = () => setCount(null)
 *
 *   // --
 *
 *   const [date, setDate] = useQueryState(
 *     'date',
 *     queryTypes.isoDateTime.withDefault(new Date('2021-01-01'))
 *   )
 *
 *   const setToNow = () => setDate(new Date())
 *   const addOneHour = () => {
 *     setDate(oldDate => new Date(oldDate.valueOf() + 3600_000))
 *   }
 * ```
 * @param key The URL query string key to bind to
 * @param options - Serializers (defines the state data type), optional default value and history mode.
 */
function useQueryState(key, { history = 'replace', parse = x => x, serialize = String, defaultValue = undefined } = {
    history: 'replace',
    parse: x => x,
    serialize: String,
    defaultValue: undefined
}) {
    var _a;
    const router = useRouter();
    // Memoizing the update function has the advantage of making it
    // immutable as long as `history` stays the same.
    // It reduces the amount of reactivity needed to update the state.
    const updateUrl = React.useMemo(() => (history === 'push' ? router.push : router.replace), [history]);
    const getValue = React.useCallback(() => {
        if (typeof window === 'undefined') {
            // Not available in an SSR context
            return null;
        }
        const query = new URLSearchParams(window.location.search);
        const value = query.get(key);
        return value !== null ? parse(value) : null;
    }, []);
    // Update the state value only when the relevant key changes.
    // Because we're not calling getValue in the function argument
    // of React.useMemo, but instead using it as the function to call,
    // there is no need to pass it in the dependency array.
    const value = React.useMemo(getValue, [router.query[key]]);
    const update = React.useCallback((stateUpdater, // todo: This is wrong now
    transitionOptions) => {
        var _a, _b;
        const isUpdaterFunction = (input) => {
            return typeof input === 'function';
        };
        // Resolve the new value based on old value & updater
        const oldValue = (_b = (_a = getValue()) !== null && _a !== void 0 ? _a : defaultValue) !== null && _b !== void 0 ? _b : null;
        const newValue = isUpdaterFunction(stateUpdater)
            ? stateUpdater(oldValue)
            : stateUpdater;
        // We can't rely on router.query here to avoid causing
        // unnecessary renders when other query parameters change.
        // URLSearchParams is already polyfilled by Next.js
        const query = new URLSearchParams(window.location.search);
        if (newValue === null) {
            // Don't leave value-less keys hanging
            query.delete(key);
        }
        else {
            query.set(key, serialize(newValue));
        }
        const search = query.toString();
        const hash = window.location.hash;
        return updateUrl === null || updateUrl === void 0 ? void 0 : updateUrl.call(router, {
            pathname: router.pathname,
            hash,
            search
        }, {
            pathname: window.location.pathname,
            hash,
            search
        }, transitionOptions);
    }, [key, updateUrl]);
    return [(_a = value !== null && value !== void 0 ? value : defaultValue) !== null && _a !== void 0 ? _a : null, update];
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/next-usequerystate@1.7.2_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-usequerystate/dist/esm/useQueryStates.js


/**
 * Synchronise multiple query string arguments to React state in Next.js
 *
 * @param keys - An object describing the keys to synchronise and how to
 *               serialise and parse them.
 *               Use `queryTypes.(string|integer|float)` for quick shorthands.
 */
function useQueryStates(keys, { history = 'replace' } = {}) {
    const router = (0,next_router.useRouter)();
    // Memoizing the update function has the advantage of making it
    // immutable as long as `history` stays the same.
    // It reduces the amount of reactivity needed to update the state.
    const updateUrl = react.useMemo(() => (history === 'push' ? router.push : router.replace), [history]);
    const getValues = react.useCallback(() => {
        if (typeof window === 'undefined') {
            // Not available in an SSR context, return all null (or default if available)
            return Object.keys(keys).reduce((obj, key) => {
                const { defaultValue } = keys[key];
                return Object.assign(Object.assign({}, obj), { [key]: defaultValue !== null && defaultValue !== void 0 ? defaultValue : null });
            }, {});
        }
        const query = new URLSearchParams(window.location.search);
        return Object.keys(keys).reduce((values, key) => {
            var _a, _b;
            const { parse, defaultValue } = keys[key];
            const value = query.get(key);
            const parsed = value !== null
                ? (_b = (_a = parse(value)) !== null && _a !== void 0 ? _a : defaultValue) !== null && _b !== void 0 ? _b : null
                : defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
            return Object.assign(Object.assign({}, values), { [key]: parsed });
        }, {});
    }, [keys]);
    // Update the state values only when the relevant keys change.
    // Because we're not calling getValues in the function argument
    // of React.useMemo, but instead using it as the function to call,
    // there is no need to pass it in the dependency array.
    const values = react.useMemo(getValues, Object.keys(keys).map(key => router.query[key]));
    const update = react.useCallback((stateUpdater, transitionOptions) => {
        const isUpdaterFunction = (input) => {
            return typeof input === 'function';
        };
        // Resolve the new values based on old values & updater
        const oldValues = getValues();
        const newValues = isUpdaterFunction(stateUpdater)
            ? stateUpdater(oldValues)
            : stateUpdater;
        // We can't rely on router.query here to avoid causing
        // unnecessary renders when other query parameters change.
        // URLSearchParams is already polyfilled by Next.js
        const query = new URLSearchParams(window.location.search);
        Object.keys(newValues).forEach(key => {
            const newValue = newValues[key];
            if (newValue === null) {
                query.delete(key);
            }
            else if (newValue !== undefined) {
                const { serialize = String } = keys[key];
                query.set(key, serialize(newValue));
            }
        });
        const search = query.toString();
        const hash = window.location.hash;
        return updateUrl === null || updateUrl === void 0 ? void 0 : updateUrl.call(router, {
            pathname: router.pathname,
            hash,
            search
        }, {
            pathname: window.location.pathname,
            hash,
            search
        }, transitionOptions);
    }, [keys, updateUrl]);
    return [values, update];
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/next-usequerystate@1.7.2_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-usequerystate/dist/esm/index.js





/***/ }),

/***/ 23244:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parks",
      function () {
        return __webpack_require__(77627);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ParksApi; }
/* harmony export */ });
/* harmony import */ var _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74552);

class ParksApi {
    getParksByType(params, parksParams) {
        var ref, ref1;
        return this.client.get("".concat(this.baseUrl), {
            params: {
                page: params.page,
                limit: params.limit,
                search: params.search,
                random: parksParams.random || null,
                "filter.parkType": parksParams.type ? "$eq:".concat(parksParams.type) : null,
                ...(parksParams === null || parksParams === void 0 ? void 0 : (ref = parksParams.states) === null || ref === void 0 ? void 0 : ref.length) ? {
                    "filter.states": "$in:".concat(parksParams.states.join(","))
                } : {},
                ...(parksParams === null || parksParams === void 0 ? void 0 : (ref1 = parksParams.tags) === null || ref1 === void 0 ? void 0 : ref1.length) ? {
                    "filter.tags.name": "$in:".concat(parksParams.tags.join(","))
                } : {},
                ...(parksParams === null || parksParams === void 0 ? void 0 : parksParams.sortBy) ? {
                    sortBy: parksParams.sortBy
                } : {}
            }
        }, false);
    }
    getParks(paginationParams) {
        return this.client.get("".concat(this.baseUrl), {
            params: {
                ...paginationParams
            }
        }, false);
    }
    getPark(idOrSlug) {
        return this.client.get("".concat(this.baseUrl, "/").concat(idOrSlug), {}, false);
    }
    async getParkVideos(idOrSlug, params) {
        return this.client.get("".concat(this.baseUrl, "/").concat(idOrSlug, "/popular_videos"), {
            params
        }, false);
    }
    async getSponsorsVideos(idOrSlug, sponsorId) {
        return this.client.get("".concat(this.baseUrl, "/").concat(idOrSlug, "/sponsor_videos?sponsor=").concat(sponsorId), {}, false);
    }
    async getParkAuthors(idOrSlug, params) {
        return this.client.get("".concat(this.baseUrl, "/").concat(idOrSlug, "/popular_authors"), {
            params
        }, false);
    }
    constructor(client = new _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__/* .HttpClient */ .e()){
        this.client = client;
        this.baseUrl = "/api/parks";
    }
}


/***/ }),

/***/ 49366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ TagsApi; }
/* harmony export */ });
/* harmony import */ var _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74552);

class TagsApi {
    getTags(params) {
        return this.client.get("".concat(this.baseUrl), {
            params
        }, false);
    }
    constructor(client = new _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__/* .HttpClient */ .e()){
        this.client = client;
        this.baseUrl = "/api/tags";
    }
}


/***/ }),

/***/ 43624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ DebouncedSearch; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ../ui/src/icons/SearchIcon/SearchIcon.tsx


const SearchIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,jsx_runtime.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19.25 19.25L15.2625 15.2625M17.4167 10.0833C17.4167 14.1334 14.1334 17.4167 10.0833 17.4167C6.03325 17.4167 2.75 14.1334 2.75 10.0833C2.75 6.03325 6.03325 2.75 10.0833 2.75C14.1334 2.75 17.4167 6.03325 17.4167 10.0833Z",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

// EXTERNAL MODULE: ../ui/src/components/Form/Inputs/Text.tsx
var Text = __webpack_require__(43403);
// EXTERNAL MODULE: ../ui/src/icons/CloseIcon/CloseIcon.tsx
var CloseIcon = __webpack_require__(71023);
// EXTERNAL MODULE: ../../node_modules/.pnpm/usehooks-ts@2.9.1_biqbaboplfbrettd7655fr4n2y/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(49531);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./modules/Forms/DebouncedSearch/DebouncedSearch.tsx





const DebouncedSearch = (param)=>{
    let { value , onChange , placeholder  } = param;
    const wrapperRef = (0,react.useRef)(null);
    const [search, setSearch] = (0,react.useState)(value);
    const [focused, setFocused] = (0,react.useState)(false);
    const debounced = (0,esm/* useDebounce */.Nr)(search);
    const onFocus = ()=>{
        setFocused(true);
    };
    const onBlur = ()=>{
        setFocused(false);
    };
    const onClear = ()=>{
        setSearch("");
    };
    (0,react.useEffect)(()=>{
        if (debounced === value) return;
        onChange(debounced || "");
    }, [
        debounced
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: "relative w-full max-w-[740px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {
                className: classnames_default()("absolute top-1/2 left-2 -translate-y-1/2", {
                    "text-neutral-200": !focused,
                    "text-neutral-600": focused
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                placeholder: placeholder,
                onChange: (e)=>setSearch(e.target.value),
                value: search,
                className: "pl-10 pr-8",
                onFocus: onFocus,
                onBlur: onBlur
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: classnames_default()("w-6 h-6 flex justify-center items-center absolute top-1/2 -translate-y-1/2 right-2 hover:opacity-100", {
                    "opacity-100": focused,
                    "opacity-0": !focused
                }),
                type: "button",
                onClick: onClear,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                    className: "w-3 h-3 text-neutral-400 stroke-[1px]",
                    strokeWidth: 1
                })
            })
        ]
    });
};


/***/ }),

/***/ 65748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ParkImage; },
/* harmony export */   "z": function() { return /* binding */ ParkImageSize; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43463);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Config_ConfigContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65729);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);




const ParkImage = (props)=>{
    const { fill , className , size , ...rest } = props;
    const { imgixConfig  } = (0,_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_3__/* .useConfig */ .ZR)();
    const calculatedSize = {
        [ParkImageSize.Thumbnail]: [
            400,
            200
        ],
        [ParkImageSize.Background]: [
            1600,
            600
        ]
    }[size];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        loader: (e)=>"https://".concat(imgixConfig.s3Domain, ".imgix.net/").concat(e.src, "?w=").concat(e.width, "&auto=compress"),
        loading: "eager",
        width: calculatedSize[0],
        height: calculatedSize[1],
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, {
            "absolute top-0 left-0 w-full h-full": fill
        }),
        ...rest
    });
};
var ParkImageSize;
(function(ParkImageSize) {
    ParkImageSize[ParkImageSize["Thumbnail"] = 0] = "Thumbnail";
    ParkImageSize[ParkImageSize["Background"] = 1] = "Background";
})(ParkImageSize || (ParkImageSize = {}));


/***/ }),

/***/ 7336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ useParks; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
// EXTERNAL MODULE: ./modules/Api/Parks/index.ts
var Parks = __webpack_require__(36604);
// EXTERNAL MODULE: ../next-utils/src/lib/env.ts
var env = __webpack_require__(57399);
;// CONCATENATED MODULE: ./modules/Api/Wordpress/WordpressApi.ts

class WordpressApi {
    getParkArticles(parkSlug) {
        return fetch("".concat(this.baseUrl, "/wp-json/wp/v2/park_content/?park_name=").concat(parkSlug, "&_embed"), {
            method: "GET"
        }).then((res)=>res.json());
    }
    constructor(baseUrl = (0,env/* getEnvVariables */.S)()["WORDPRESS_URL"]){
        this.baseUrl = baseUrl;
    }
}

// EXTERNAL MODULE: ./modules/Config/ConfigContext.tsx
var ConfigContext = __webpack_require__(65729);
;// CONCATENATED MODULE: ./modules/Parks/hooks.ts




const useParks = ()=>{
    const { wordpressUrl  } = (0,ConfigContext/* useConfig */.ZR)();
    const parkApi = new Parks/* ParksApi */.y();
    const wordpressApi = new WordpressApi(wordpressUrl);
    const useParksQuery = (pagination, parksParams, config)=>(0,index_production.useQuery)([
            "parks",
            pagination,
            parksParams
        ], ()=>parkApi.getParksByType(pagination, parksParams), {
            ...config
        });
    const useParkQuery = (id)=>(0,index_production.useQuery)([
            "parks",
            id
        ], async ()=>await parkApi.getPark(id));
    const useParkArticles = (slugOrId)=>(0,index_production.useQuery)([
            "wordpress",
            "park-articles",
            slugOrId
        ], async ()=>wordpressApi.getParkArticles(slugOrId));
    const useSponsorVideos = (id, sponsorId, config)=>{
        return (0,index_production.useQuery)([
            "videos",
            "park",
            "sponsor",
            id,
            sponsorId
        ], async ()=>await parkApi.getSponsorsVideos(id, sponsorId), {
            keepPreviousData: true,
            ...config
        });
    };
    const useParkVideos = (id, pagination, config)=>{
        return (0,index_production.useQuery)([
            "videos",
            "park",
            id,
            pagination
        ], async ()=>await parkApi.getParkVideos(id, pagination), {
            keepPreviousData: true,
            ...config
        });
    };
    const useParkAuthors = (id, pagination, config)=>{
        return (0,index_production.useQuery)([
            "authors",
            "park",
            id,
            pagination
        ], async ()=>await parkApi.getParkAuthors(id, pagination), {
            keepPreviousData: true,
            ...config
        });
    };
    return {
        useParksQuery,
        useParkQuery,
        useParkVideos,
        useParkAuthors,
        useParkArticles,
        useSponsorVideos
    };
};


/***/ }),

/***/ 10686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useResolveParkPagePath; }
/* harmony export */ });
/* harmony import */ var _Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65729);

const useResolveParkPagePath = (slugOrId)=>{
    const { pageUrl  } = (0,_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__/* .useConfig */ .ZR)();
    return "".concat(pageUrl, "/parks/").concat(slugOrId);
};


/***/ }),

/***/ 77627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ parks; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/OutsidePageWrapper.tsx
var OutsidePageWrapper = __webpack_require__(55368);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/InsidePageWrapper.tsx
var InsidePageWrapper = __webpack_require__(70996);
// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
// EXTERNAL MODULE: ../ui/src/components/ItemsList/ItemsList.tsx
var ItemsList = __webpack_require__(14927);
// EXTERNAL MODULE: ../ui/src/components/Pagination/Pagination.tsx
var Pagination = __webpack_require__(4015);
// EXTERNAL MODULE: ./utils/useScrollTo/useScrollTo.tsx
var useScrollTo = __webpack_require__(77795);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ../ui/src/icons/ArrowRight/ArrowRight.tsx
var ArrowRight = __webpack_require__(71740);
// EXTERNAL MODULE: ../ui/src/icons/VideoCameraIcon/VideoCameraOutlineIcon.tsx
var VideoCameraOutlineIcon = __webpack_require__(82032);
// EXTERNAL MODULE: ../ui/src/icons/UserIcon/UserIcon.tsx
var UserIcon = __webpack_require__(89880);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/link.js
var next_link = __webpack_require__(66998);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./modules/Parks/path.ts
var path = __webpack_require__(10686);
// EXTERNAL MODULE: ./modules/Parks/ParkImage.tsx
var ParkImage = __webpack_require__(65748);
// EXTERNAL MODULE: ./utils/useAnalytics.tsx
var useAnalytics = __webpack_require__(24900);
// EXTERNAL MODULE: ./modules/ImgixImage/index.tsx
var ImgixImage = __webpack_require__(86645);
;// CONCATENATED MODULE: ./modules/Parks/ParkCard/ParkCardWithSticker.tsx









const ParkCardWithSticker = (param)=>{
    let { data  } = param;
    const { onButtonClick  } = (0,useAnalytics/* useAnalytics */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: (0,path/* useResolveParkPagePath */.A)(data.slug),
        onClick: ()=>onButtonClick("goToParkPage"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: classnames_default()("min-h-[328px] relative p-3 bg-white rounded-xl w-full min-w-[344px] grow drop-shadow hover:shadow-lg group transition-all duration-200 cursor-pointer"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("relative w-full rounded-xl overflow-hidden bg-neutral-100 h-[142px]"),
                    children: [
                        data.backgroundKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ParkImage/* ParkImage */.$, {
                            src: data.backgroundKey,
                            alt: data.fullName,
                            size: ParkImage/* ParkImageSize.Thumbnail */.z.Thumbnail,
                            className: "object-cover group-hover:scale-110 transition",
                            fill: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                            src: "/media/default-park-background.webp",
                            alt: "Park cover",
                            fill: true,
                            className: "object-cover group-hover:scale-110 transition"
                        }),
                        data.stickerKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute bottom-3 left-3 w-[58px] h-[58px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgixImage/* ImgixImage */.T, {
                                src: data.stickerKey,
                                alt: data.name,
                                fill: true,
                                className: "object-contain"
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative py-2 lg:pt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex gap-2 justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full max-w-[80%]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            component: "h3",
                                            variant: "h4",
                                            className: "line-clamp-1 text-neutral-900 mt-1 lg:!leading-[26px]",
                                            children: data.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "w-full line-clamp-1 grow -mt-[2px]",
                                            children: data.states.map((state)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "relative mr-3 inline-block text-xs text-neutral-500 before:absolute before:top-[5%] before:-left-[8px] before:content-['.'] before:text-neutral-200 before:text-2xl before:leading-[1px] first:before:content-none",
                                                    children: state
                                                }, state))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-12 h-12 flex justify-center items-center shadow-md rounded-xl text-neutral-400 group-hover:text-white group-hover:shadow-lg group-hover:bg-gradient-to-r group-hover:from-primary-500 group-hover:to-primary-600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                        className: "w-6 h-6"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            variant: "bodyBase",
                            className: "line-clamp-3 text-neutral-500 min-h-[48px] mt-2 lg:line-clamp-3 lg:min-h-[54px]",
                            children: data.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-3 flex gap-3 items-center",
                            children: [
                                !!data.videosCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                    variant: "bodySmall",
                                    className: "text-neutral-500 flex gap-1 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCameraOutlineIcon/* VideoCameraOutlineIcon */.s, {
                                            className: "text-neutral-500 w-[14px] h-[14px]"
                                        }),
                                        data.videosCount,
                                        " videos"
                                    ]
                                }),
                                !!data.creatorsCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                    variant: "bodySmall",
                                    className: "text-neutral-500 flex gap-1 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* UserIcon */.t, {
                                            className: "text-neutral-500 w-[12px] h-[12px]"
                                        }),
                                        data.creatorsCount,
                                        " creators"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./modules/Parks/ParksListSection/ParksListSection.tsx





const ParksList = (param)=>{
    let { pagination , data  } = param;
    const { scrollTo  } = (0,useScrollTo/* useScrollTo */.q)({
        id: "parks-videos-section"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
                className: "w-full py-6 grid gap-4 grid-cols-1 md:gap-6 md:grid-cols-2 xl:grid-cols-3",
                noItemsMessage: "Parks not found",
                items: data,
                renderItem: (park)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ParkCardWithSticker, {
                        data: park
                    })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                    pagination: pagination,
                    onPageChange: scrollTo
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/Forms/DebouncedSearch/DebouncedSearch.tsx + 1 modules
var DebouncedSearch = __webpack_require__(43624);
;// CONCATENATED MODULE: ./utils/useOutsideClick/useOutsideClick.ts

function useOutsideClick(ref, handler) {
    (0,react.useEffect)(()=>{
        const listener = (event)=>{
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [
        ref,
        handler
    ]);
}

;// CONCATENATED MODULE: ./utils/useParksParams/getParksQueryFromCtx.ts
const DEFAULT_PARKS_SORT = "videosCount:DESC";
const getParksQueryFromCtx = (ctx)=>{
    const tags = Array.isArray(ctx.query.tags) ? ctx.query.tags : (ctx.query.tags || "").split(",");
    const states = Array.isArray(ctx.query.states) ? ctx.query.states : (ctx.query.states || "").split(",");
    const type = ctx.query.type || null;
    const sortBy = ctx.query.sortBy || DEFAULT_PARKS_SORT;
    return {
        tags: tags.filter((tag)=>tag).map((tag)=>decodeURIComponent(tag)),
        states: states.filter((state)=>state).map((state)=>decodeURIComponent(state)),
        sortBy,
        type
    };
};

// EXTERNAL MODULE: ./utils/usePagination/usePaginationQuery.ts + 1 modules
var usePaginationQuery = __webpack_require__(61934);
// EXTERNAL MODULE: ./modules/Parks/hooks.ts + 1 modules
var hooks = __webpack_require__(7336);
// EXTERNAL MODULE: ../ui/src/components/Button/Button.tsx
var Button = __webpack_require__(57100);
// EXTERNAL MODULE: ../ui/src/icons/CloseIcon/CloseIcon.tsx
var CloseIcon = __webpack_require__(71023);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-hook-form@7.34.2_react@18.2.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(65620);
// EXTERNAL MODULE: ../ui/src/components/Form/Inputs/CheckBox.tsx
var CheckBox = __webpack_require__(78897);
// EXTERNAL MODULE: ./modules/Api/Tags/index.ts
var Tags = __webpack_require__(49366);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
;// CONCATENATED MODULE: ./modules/Tags/hooks.ts


const useTags = ()=>{
    const tagsApi = new Tags/* TagsApi */.v();
    const useGetTagsQuery = (pagination, config)=>(0,index_production.useQuery)([
            "tags",
            pagination
        ], async ()=>await tagsApi.getTags(pagination), {
            refetchOnMount: false,
            ...config
        });
    return {
        useGetTagsQuery
    };
};

// EXTERNAL MODULE: ../ui/src/icons/ChevronLeft/ChevronLeft.tsx
var ChevronLeft = __webpack_require__(7595);
;// CONCATENATED MODULE: ./modules/Pages/ParksPage/AdvancedFilters/AdvancedFiltersComponents.tsx



function AdvancedFiltersNavigationHeader(param) {
    let { onBack , title  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "py-2 flex gap-2 items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: onBack,
                className: "mb-[2px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* ChevronLeft */.s, {
                    className: "w-5 h-5 text-neutral-700"
                })
            }),
            title
        ]
    });
}

;// CONCATENATED MODULE: ./modules/Pages/ParksPage/AdvancedFilters/Views/Tags.tsx








function AdvancedFiltersTags(param) {
    let { onBack , onFilter , initialTags  } = param;
    const [search, setSearch] = (0,react.useState)("");
    const { register , handleSubmit  } = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            selectedStates: initialTags
        }
    });
    const { useGetTagsQuery  } = useTags();
    const { data: tags  } = useGetTagsQuery({
        page: 1,
        limit: 1000,
        search: search
    }, {
        keepPreviousData: true
    });
    const onSubmit = (data)=>{
        onFilter(data.selectedStates);
    };
    const onSearch = (value)=>{
        if (!value) return setSearch("");
        setSearch(value);
    };
    const renderTagsList = ()=>{
        if (!tags) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersListSkeleton, {});
        }
        return tags.data.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
                    id: tag.id,
                    htmlFor: tag.id,
                    type: "checkbox",
                    value: tag.name,
                    text: tag.name,
                    ...register("selectedStates")
                })
            }, tag.id));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "h-[100%] flex flex-col justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grow max-h-[calc(100%-40px)]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersNavigationHeader, {
                        onBack: onBack,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            variant: "bodyLarge",
                            className: "text-neutral-700",
                            children: "Choose tags"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DebouncedSearch/* DebouncedSearch */.C, {
                            placeholder: "Search for anything",
                            value: search,
                            onChange: onSearch
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4 w-full max-h-[calc(100%-124px)] overflow-y-auto p-2 flex flex-col gap-6",
                        children: renderTagsList()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        type: "button",
                        variant: "base",
                        onClick: onBack,
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        type: "submit",
                        className: "w-full",
                        children: "Add Filter"
                    })
                ]
            })
        ]
    });
}
function AdvancedFiltersTagSkeleton(param) {
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("h-[20px] bg-neutral-100 animate-pulse rounded", className)
    });
}
function AdvancedFiltersListSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[40%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[30%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[50%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[45%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[20%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[60%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[45%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[40%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[40%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[50%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[30%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[37%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[45%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[25%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[38%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[55%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[25%]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTagSkeleton, {
                className: "w-[30%]"
            })
        ]
    });
}

;// CONCATENATED MODULE: ../map/src/Map/statesOptions.ts
var OptionType;
(function(OptionType) {
    OptionType["STATE"] = "state";
    OptionType["COUNTRY"] = "country";
})(OptionType || (OptionType = {}));
const states = [
    {
        value: "Alabama",
        label: "Alabama",
        type: OptionType.STATE
    },
    {
        value: "Alaska",
        label: "Alaska",
        type: OptionType.STATE
    },
    {
        value: "American Samoa",
        label: "American Samoa",
        type: OptionType.STATE
    },
    {
        value: "Arizona",
        label: "Arizona",
        type: OptionType.STATE
    },
    {
        value: "Arkansas",
        label: "Arkansas",
        type: OptionType.STATE
    },
    {
        value: "California",
        label: "California",
        type: OptionType.STATE
    },
    {
        value: "Colorado",
        label: "Colorado",
        type: OptionType.STATE
    },
    {
        value: "Connecticut",
        label: "Connecticut",
        type: OptionType.STATE
    },
    {
        value: "Delaware",
        label: "Delaware",
        type: OptionType.STATE
    },
    {
        value: "District Of Columbia",
        label: "District Of Columbia",
        type: OptionType.STATE
    },
    {
        value: "Washington, DC",
        label: "Washington, DC",
        type: OptionType.STATE
    },
    {
        value: "Federated States Of Micronesia",
        label: "Federated States Of Micronesia",
        type: OptionType.STATE
    },
    {
        value: "Florida",
        label: "Florida",
        type: OptionType.STATE
    },
    {
        value: "Georgia",
        label: "Georgia",
        type: OptionType.STATE
    },
    {
        value: "Guam",
        label: "Guam",
        type: OptionType.STATE
    },
    {
        value: "Hawaii",
        label: "Hawaii",
        type: OptionType.STATE
    },
    {
        value: "Idaho",
        label: "Idaho",
        type: OptionType.STATE
    },
    {
        value: "Illinois",
        label: "Illinois",
        type: OptionType.STATE
    },
    {
        value: "Indiana",
        label: "Indiana",
        type: OptionType.STATE
    },
    {
        value: "Iowa",
        label: "Iowa",
        type: OptionType.STATE
    },
    {
        value: "Kansas",
        label: "Kansas",
        type: OptionType.STATE
    },
    {
        value: "Kentucky",
        label: "Kentucky",
        type: OptionType.STATE
    },
    {
        value: "Louisiana",
        label: "Louisiana",
        type: OptionType.STATE
    },
    {
        value: "Maine",
        label: "Maine",
        type: OptionType.STATE
    },
    {
        value: "Marshall Islands",
        label: "Marshall Islands",
        type: OptionType.STATE
    },
    {
        value: "Maryland",
        label: "Maryland",
        type: OptionType.STATE
    },
    {
        value: "Massachusetts",
        label: "Massachusetts",
        type: OptionType.STATE
    },
    {
        value: "Michigan",
        label: "Michigan",
        type: OptionType.STATE
    },
    {
        value: "Minnesota",
        label: "Minnesota",
        type: OptionType.STATE
    },
    {
        value: "Mississippi",
        label: "Mississippi",
        type: OptionType.STATE
    },
    {
        value: "Missouri",
        label: "Missouri",
        type: OptionType.STATE
    },
    {
        value: "Montana",
        label: "Montana",
        type: OptionType.STATE
    },
    {
        value: "Nebraska",
        label: "Nebraska",
        type: OptionType.STATE
    },
    {
        value: "Nevada",
        label: "Nevada",
        type: OptionType.STATE
    },
    {
        value: "New Hampshire",
        label: "New Hampshire",
        type: OptionType.STATE
    },
    {
        value: "New Jersey",
        label: "New Jersey",
        type: OptionType.STATE
    },
    {
        value: "New Mexico",
        label: "New Mexico",
        type: OptionType.STATE
    },
    {
        value: "New York",
        label: "New York",
        type: OptionType.STATE
    },
    {
        value: "North Carolina",
        label: "North Carolina",
        type: OptionType.STATE
    },
    {
        value: "North Dakota",
        label: "North Dakota",
        type: OptionType.STATE
    },
    {
        value: "Northern Mariana Islands",
        label: "Northern Mariana Islands",
        type: OptionType.STATE
    },
    {
        value: "Ohio",
        label: "Ohio",
        type: OptionType.STATE
    },
    {
        value: "Oklahoma",
        label: "Oklahoma",
        type: OptionType.STATE
    },
    {
        value: "Oregon",
        label: "Oregon",
        type: OptionType.STATE
    },
    {
        value: "Palau",
        label: "Palau",
        type: OptionType.STATE
    },
    {
        value: "Pennsylvania",
        label: "Pennsylvania",
        type: OptionType.STATE
    },
    {
        value: "Puerto Rico",
        label: "Puerto Rico",
        type: OptionType.STATE
    },
    {
        value: "Rhode Island",
        label: "Rhode Island",
        type: OptionType.STATE
    },
    {
        value: "South Carolina",
        label: "South Carolina",
        type: OptionType.STATE
    },
    {
        value: "South Dakota",
        label: "South Dakota",
        type: OptionType.STATE
    },
    {
        value: "Tennessee",
        label: "Tennessee",
        type: OptionType.STATE
    },
    {
        value: "Texas",
        label: "Texas",
        type: OptionType.STATE
    },
    {
        value: "Utah",
        label: "Utah",
        type: OptionType.STATE
    },
    {
        value: "Vermont",
        label: "Vermont",
        type: OptionType.STATE
    },
    {
        value: "Virgin Islands",
        label: "Virgin Islands",
        type: OptionType.STATE
    },
    {
        value: "Virginia",
        label: "Virginia",
        type: OptionType.STATE
    },
    {
        value: "Washington",
        label: "Washington",
        type: OptionType.STATE
    },
    {
        value: "West Virginia",
        label: "West Virginia",
        type: OptionType.STATE
    },
    {
        value: "Wisconsin",
        label: "Wisconsin",
        type: OptionType.STATE
    },
    {
        value: "Wyoming",
        label: "Wyoming",
        type: OptionType.STATE
    }
];

;// CONCATENATED MODULE: ./modules/Pages/ParksPage/AdvancedFilters/Views/States.tsx







function AdvancedFiltersStates(param) {
    let { onBack , onFilter , initialStates  } = param;
    const [search, setSearch] = (0,react.useState)("");
    const [filteredStates, setFilteredStates] = (0,react.useState)(states);
    const { register , handleSubmit  } = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            selectedStates: initialStates
        }
    });
    const onSubmit = (data)=>{
        onFilter(data.selectedStates);
    };
    const onSearch = (value)=>{
        if (!value) return setSearch("");
        setSearch(value);
    };
    (0,react.useEffect)(()=>{
        setFilteredStates(states.filter((state)=>state.value.toLowerCase().includes(search.toLowerCase())));
    }, [
        search
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "h-[100%] flex flex-col justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grow max-h-[calc(100%-40px)]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersNavigationHeader, {
                        onBack: onBack,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            variant: "bodyLarge",
                            className: "text-neutral-700",
                            children: "Choose states"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DebouncedSearch/* DebouncedSearch */.C, {
                            placeholder: "Search for anything",
                            value: search,
                            onChange: onSearch
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4 w-full max-h-[calc(100%-124px)] overflow-y-auto p-2 flex flex-col gap-6",
                        children: filteredStates.map((state)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
                                    id: state.value,
                                    htmlFor: state.value,
                                    type: "checkbox",
                                    value: state.value,
                                    text: state.label,
                                    ...register("selectedStates")
                                })
                            }, state.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        type: "button",
                        variant: "base",
                        onClick: onBack,
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        type: "submit",
                        className: "w-full",
                        children: "Add Filter"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ../ui/src/icons/SortByIcon/SortByIcon.tsx


const SortByIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 2H9.47059M1 8H7.58824M1 14H7.58824M11.3529 11L14.1765 14M14.1765 14L17 11M14.1765 14V2",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../ui/src/icons/FilterIcon/FilterIcon.tsx


const FilterIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,jsx_runtime.jsx)("svg", {
        className: className,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.625 8.5C3.19402 8.5 2.7807 8.32879 2.47595 8.02405C2.1712 7.7193 2 7.30598 2 6.875C2 6.44402 2.1712 6.0307 2.47595 5.72595C2.7807 5.42121 3.19402 5.25 3.625 5.25M3.625 8.5C4.05598 8.5 4.4693 8.32879 4.77405 8.02405C5.0788 7.7193 5.25 7.30598 5.25 6.875C5.25 6.44402 5.0788 6.0307 4.77405 5.72595C4.4693 5.42121 4.05598 5.25 3.625 5.25M3.625 8.5V15M3.625 5.25V2M8.5 13.375C8.06902 13.375 7.6557 13.2038 7.35095 12.899C7.04621 12.5943 6.875 12.181 6.875 11.75C6.875 11.319 7.04621 10.9057 7.35095 10.601C7.6557 10.2962 8.06902 10.125 8.5 10.125M8.5 13.375C8.93098 13.375 9.3443 13.2038 9.64905 12.899C9.95379 12.5943 10.125 12.181 10.125 11.75C10.125 11.319 9.95379 10.9057 9.64905 10.601C9.3443 10.2962 8.93098 10.125 8.5 10.125M8.5 13.375V15M8.5 10.125V2M13.375 6.0625C12.944 6.0625 12.5307 5.89129 12.226 5.58655C11.9212 5.2818 11.75 4.86848 11.75 4.4375C11.75 4.00652 11.9212 3.5932 12.226 3.28845C12.5307 2.9837 12.944 2.8125 13.375 2.8125M13.375 6.0625C13.806 6.0625 14.2193 5.89129 14.524 5.58655C14.8288 5.2818 15 4.86848 15 4.4375C15 4.00652 14.8288 3.5932 14.524 3.28845C14.2193 2.9837 13.806 2.8125 13.375 2.8125M13.375 6.0625V15M13.375 2.8125V2",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

// EXTERNAL MODULE: ../ui/src/icons/ChevronRight/ChevronRight.tsx
var ChevronRight = __webpack_require__(98427);
;// CONCATENATED MODULE: ../ui/src/components/Form/Inputs/Radio.tsx



const Radio = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { text , description , className , disabled , labelClassName , htmlFor , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex items-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center h-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    ref: ref,
                    ...rest,
                    disabled: disabled,
                    type: "radio",
                    className: classnames_default()("h-4 w-4 rounded-full", {
                        "text-primary-500 !ring-primary-600": !disabled,
                        "text-neutral-400 !ring-neutral-500": disabled
                    }, className)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-3 text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : rest.name,
                        className: classnames_default()("text-sm", {
                            "text-gray-700": !disabled,
                            "text-neutral-500": disabled
                        }, labelClassName),
                        children: text
                    }),
                    description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()({
                            "text-gray-500": !disabled,
                            "text-gray-300": disabled
                        }),
                        children: description
                    }) : null
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ./modules/Pages/ParksPage/AdvancedFilters/Views/Summary.tsx





function AdvancedFiltersView(param) {
    let { onFilter , onCancel , onStatesClick , onTagsClick , onSortChange , onClear , states , tags , children , sortBy  } = param;
    const allFiltersLength = tags.length + states.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col gap-2 justify-between h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2 mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByIcon, {
                                        className: "w-4 h-4 text-neutral-700"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        component: "h4",
                                        variant: "bodyLarge",
                                        className: "text-neutral-700 mt-1",
                                        children: "Sort by"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSortFilters, {
                                onChange: onSortChange,
                                initialSortBy: sortBy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4 py-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterIcon, {
                                        className: "w-4 h-4 text-neutral-700"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        component: "h4",
                                        variant: "bodyLarge",
                                        className: "text-neutral-700 mt-1",
                                        children: "Filters"
                                    })
                                ]
                            }),
                            allFiltersLength > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: onClear,
                                className: "text-[11px] underline text-neutral-700",
                                children: "clear all"
                            }) : null
                        ]
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-4 mt-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersViewButton, {
                                onClick: onStatesClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            variant: "bodyLarge",
                                            className: "text-neutral-900 font-medium",
                                            children: "State"
                                        }),
                                        states.length === 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Indicator, {
                                            children: states.length
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersViewButton, {
                                onClick: onTagsClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            variant: "bodyLarge",
                                            className: "text-neutral-900 font-medium",
                                            children: "Tags"
                                        }),
                                        tags.length === 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Indicator, {
                                            children: tags.length
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 mt-4 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        variant: "base",
                        onClick: onCancel,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        onClick: onFilter,
                        className: "w-full",
                        children: "Find Parks"
                    })
                ]
            })
        ]
    });
}
function AdvancedSelectedFilters(param) {
    let { onStateRemove , onTagRemove , states , tags  } = param;
    const allFiltersLength = tags.length + states.length;
    if (allFiltersLength === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSingleFilter, {
            title: "No filters chosen"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
                noItemsMessage: "",
                liClassName: "!w-fit",
                noItemsClassName: "!hidden",
                className: "flex gap-2 flex-wrap mb-2",
                items: states.map((state)=>({
                        id: state,
                        value: state
                    })),
                renderItem: (state)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSingleFilter, {
                        title: state.value,
                        onClick: ()=>onStateRemove(state.id)
                    })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
                noItemsMessage: "",
                liClassName: "!w-fit",
                noItemsClassName: "!hidden",
                className: "flex gap-2 flex-wrap",
                items: tags.map((tag)=>({
                        id: tag,
                        value: tag
                    })),
                renderItem: (tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSingleFilter, {
                        title: tag.value,
                        onClick: ()=>onTagRemove(tag.id)
                    })
            })
        ]
    });
}
function AdvancedSingleFilter(param) {
    let { title , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-2 items-center px-4 py-2 bg-neutral-100 rounded-full w-fit",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                variant: "bodySmall",
                className: classnames_default()({
                    "text-neutral-700": onClick,
                    "text-neutral-400": !onClick
                }),
                children: title
            }),
            onClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "w-4 h-4 flex justify-center items-center",
                onClick: onClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                    className: "w-2 h-2"
                })
            }) : null
        ]
    });
}
function Indicator(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-white rounded-full px-[7px] border-2 border-white text-xs bg-blue-500",
        children: children
    });
}
function AdvancedFiltersViewButton(param) {
    let { onClick , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: "w-full bg-neutral-100 px-2 py-3 rounded-lg flex justify-between items-center hover:bg-neutral-50",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* ChevronRight */._, {
                className: "w-5 h-5 text-neutral-700"
            })
        ]
    });
}
function AdvancedSortFilters(param) {
    let { initialSortBy , onChange  } = param;
    const { register  } = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            sortBy: initialSortBy
        }
    });
    const handleOnChange = (e)=>{
        var _value;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        onChange((_value = e.target.value) !== null && _value !== void 0 ? _value : "name:ASC");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: "flex flex-col gap-2",
        onChange: handleOnChange,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                id: "name:ASC",
                htmlFor: "name:ASC",
                value: "name:ASC",
                text: "park name (A - Z)",
                ...register("sortBy")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                id: "name:DESC",
                htmlFor: "name:DESC",
                value: "name:DESC",
                text: "park name (Z - A)",
                ...register("sortBy")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                id: "videosCount:DESC",
                htmlFor: "videosCount:DESC",
                value: "videosCount:DESC",
                text: "number of videos (desc)",
                ...register("sortBy")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                id: "creatorsCount:DESC",
                htmlFor: "creatorsCount:DESC",
                value: "creatorsCount:DESC",
                text: "number of creators (desc)",
                ...register("sortBy")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./modules/Pages/ParksPage/AdvancedFilters/AdvancedFilters.tsx





function reducer(state, action) {
    switch(action.type){
        case "BACK_TO_VIEW":
            return {
                ...state,
                currentView: "view"
            };
        case "GO_TO_TAGS":
            return {
                ...state,
                currentView: "tags"
            };
        case "GO_TO_STATES":
            return {
                ...state,
                currentView: "states"
            };
        case "FILTER_TAGS":
            return {
                ...state,
                tags: action.tags,
                currentView: "view"
            };
        case "FILTER_STATES":
            return {
                ...state,
                states: action.states,
                currentView: "view"
            };
        case "CHANGE_SORT":
            return {
                ...state,
                sortBy: action.sortBy
            };
        case "CLEAR":
            return {
                ...state,
                states: [],
                tags: []
            };
    }
}
function AdvancedFilters(param) {
    let { initialStates , initialTags , initialSortBy , onFilter , onCancel  } = param;
    const [{ currentView , states , tags , sortBy  }, dispatch] = (0,react.useReducer)(reducer, {
        currentView: "view",
        states: initialStates,
        tags: initialTags,
        sortBy: initialSortBy
    });
    const goToTags = ()=>{
        dispatch({
            type: "GO_TO_TAGS"
        });
    };
    const goToStates = ()=>{
        dispatch({
            type: "GO_TO_STATES"
        });
    };
    const onStatesFilters = (newStates)=>{
        dispatch({
            type: "FILTER_STATES",
            states: newStates
        });
    };
    const onTagsFilters = (newTags)=>{
        dispatch({
            type: "FILTER_TAGS",
            tags: newTags
        });
    };
    const onStateRemove = (id)=>{
        dispatch({
            type: "FILTER_STATES",
            states: states.filter((state)=>state !== id)
        });
    };
    const onTagRemove = (id)=>{
        dispatch({
            type: "FILTER_TAGS",
            tags: tags.filter((tag)=>tag !== id)
        });
    };
    const onSortChange = (sort)=>{
        dispatch({
            type: "CHANGE_SORT",
            sortBy: sort
        });
    };
    const onClear = ()=>{
        dispatch({
            type: "CLEAR"
        });
    };
    const back = ()=>{
        dispatch({
            type: "BACK_TO_VIEW"
        });
    };
    const handleOnFilter = ()=>{
        onFilter(tags, states, sortBy);
    };
    const handleOnCancel = ()=>{
        onCancel();
    };
    const renderView = ()=>{
        switch(currentView){
            case "view":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersView, {
                    onCancel: handleOnCancel,
                    onFilter: handleOnFilter,
                    onStatesClick: goToStates,
                    onTagsClick: goToTags,
                    onClear: onClear,
                    onSortChange: onSortChange,
                    sortBy: sortBy,
                    states: states,
                    tags: tags,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-h-[115px] overflow-y-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSelectedFilters, {
                            onStateRemove: onStateRemove,
                            onTagRemove: onTagRemove,
                            states: states,
                            tags: tags
                        })
                    })
                });
            case "tags":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersTags, {
                    onBack: back,
                    onFilter: onTagsFilters,
                    initialTags: tags
                });
            case "states":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFiltersStates, {
                    onBack: back,
                    onFilter: onStatesFilters,
                    initialStates: states
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white rounded-xl w-full shadow h-[575px] p-4 border-[1px] border-neutral-200",
        children: renderView()
    });
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/next-usequerystate@1.7.2_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-usequerystate/dist/esm/index.js + 3 modules
var esm = __webpack_require__(73653);
;// CONCATENATED MODULE: ./modules/Pages/ParksPage/ParksFilters.tsx








const ParksFilters = (param)=>{
    let { children , pagination , queryParams  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const { useParksQuery  } = (0,hooks/* useParks */.V)();
    const handleClose = ()=>{
        setIsOpen(false);
    };
    const dropdownRef = (0,react.useRef)(null);
    useOutsideClick(dropdownRef, handleClose);
    var _tags, _states;
    const [advancedFilters, setAdvancedFilters] = (0,esm/* useQueryStates */.XI)({
        tags: esm/* queryTypes.array */.SS.array(esm/* queryTypes.string */.SS.string).withDefault((_tags = queryParams.tags) !== null && _tags !== void 0 ? _tags : []),
        states: esm/* queryTypes.array */.SS.array(esm/* queryTypes.string */.SS.string).withDefault((_states = queryParams.states) !== null && _states !== void 0 ? _states : []),
        sortBy: esm/* queryTypes.string.withDefault */.SS.string.withDefault(DEFAULT_PARKS_SORT)
    });
    const filteredTags = advancedFilters.tags.filter((tag)=>!!tag);
    const filteredStates = advancedFilters.states.filter((state)=>!!state);
    const filtersCount = filteredTags.length + filteredStates.length;
    const { data: parks , pagination: queryPagination  } = (0,usePaginationQuery/* usePaginationQuery */.Z)((paginationParams)=>useParksQuery(paginationParams, {
            ...queryParams,
            states: filteredStates,
            tags: filteredTags
        }, {
            keepPreviousData: true
        }), {
        initialPagination: pagination
    });
    const onSearch = async (search)=>{
        queryPagination.changeSearch(search);
        scrollTo();
    };
    const toggle = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const onFilter = async (tags, states, sortBy)=>{
        var ref;
        await setAdvancedFilters({
            tags,
            states,
            sortBy
        });
        (ref = queryPagination.goToFirst) === null || ref === void 0 ? void 0 : ref.call(queryPagination);
        handleClose();
    };
    if (!parks || !parks.data) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: dropdownRef,
                className: "relative flex gap-1 justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DebouncedSearch/* DebouncedSearch */.C, {
                        value: queryPagination.currentSearch,
                        onChange: onSearch,
                        placeholder: "Find a park"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        variant: "base",
                        className: "!px-3 !h-9 !min-w-[75px] !min-h-[38px] flex justify-center items-center !border-solid !border-[1px] !border-neutral-200",
                        onClick: toggle,
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-2 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    variant: "bodyBase",
                                    className: "font-bold text-neutral-500",
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
                                    className: "w-3 h-3",
                                    strokeWidth: 1
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                            variant: "bodyBase",
                            className: "font-bold text-neutral-500",
                            children: [
                                "Filter ",
                                filtersCount ? "(".concat(filtersCount, ")") : null
                            ]
                        })
                    }),
                    isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute z-10 top-[110%] right-0 w-full max-w-[450px] md:max-w-[320px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilters, {
                            initialSortBy: advancedFilters.sortBy,
                            initialStates: filteredStates,
                            initialTags: filteredTags,
                            onCancel: handleClose,
                            onFilter: onFilter
                        })
                    })
                ]
            }),
            children === null || children === void 0 ? void 0 : children({
                pagination: queryPagination,
                data: parks === null || parks === void 0 ? void 0 : parks.data
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/Parks/ParksListSection/ParksHeading.tsx



const ParksHeading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                variant: "h2",
                className: "text-neutral-900",
                children: "Discover Parks & Places"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                variant: "bodyLarge",
                className: "text-neutral-900 mb-6",
                children: "Find an amazing destination for your next trip."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/Pages/ParksPage/ParksPage.tsx







const ParksPage = (param)=>{
    let { initialPagination , parksParams  } = param;
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsidePageWrapper/* InsidePageWrapper */.n, {
            className: "flex flex-col gap-4 md:gap-6 mb-[56px] md:mt-[30px] lg:mt-10",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "parks-videos-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParksHeading, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParksFilters, {
                        pagination: initialPagination,
                        queryParams: parksParams,
                        children: (args)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ParksList, {
                                ...args
                            })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./pages/parks/index.ts

var __N_SSP = true;
/* harmony default export */ var parks = (ParksPage);


/***/ }),

/***/ 76356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useButtonsAnalytics; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24900);


const useButtonsAnalytics = ()=>{
    const { onButtonClick  } = (0,_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    const listenEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (!e || !e.target) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        onButtonClick(e.target.textContent);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!document) return;
        const buttons = document.querySelectorAll("button");
        buttons.forEach((button)=>button.addEventListener("click", listenEvent));
        return ()=>{
            buttons.forEach((button)=>button.removeEventListener("click", listenEvent));
        };
    }, []);
};


/***/ }),

/***/ 61934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ usePaginationQuery; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next-usequerystate@1.7.2_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-usequerystate/dist/esm/index.js + 3 modules
var esm = __webpack_require__(73653);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ./utils/usePagination/defaults.ts
const PAGINATION_DEFAULTS = {
    page: 1,
    limit: 12
};

;// CONCATENATED MODULE: ./utils/usePagination/usePaginationQuery.ts



function usePaginationQuery(useQuery) {
    let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        initialPagination: {
            page: PAGINATION_DEFAULTS.page,
            limit: PAGINATION_DEFAULTS.limit,
            search: null
        }
    };
    const [currentPagination, setCurrentPagination] = (0,esm/* useQueryStates */.XI)({
        page: esm/* queryTypes.integer.withDefault */.SS.integer.withDefault(config.initialPagination.page),
        limit: esm/* queryTypes.integer.withDefault */.SS.integer.withDefault(config.initialPagination.limit),
        search: esm/* queryTypes.string.withDefault */.SS.string.withDefault(config.initialPagination.search)
    });
    const query = useQuery(currentPagination);
    const { data  } = query;
    const goToNext = data && data.meta.totalPages > currentPagination.page ? ()=>setCurrentPagination((prevState)=>{
            if (prevState.page < (data ? data.meta.totalPages : 0)) prevState.page++;
            return prevState;
        }, {
            shallow: true
        }) : undefined;
    const goToPrevious = currentPagination.page > 1 ? ()=>setCurrentPagination((prevState)=>{
            if (prevState.page > 1) prevState.page--;
            return prevState;
        }, {
            shallow: true
        }) : undefined;
    const goToPage = (page)=>setCurrentPagination({
            page
        }, {
            shallow: true
        });
    const goToFirst = currentPagination.page !== 1 ? ()=>setCurrentPagination({
            page: 1
        }, {
            shallow: true
        }) : undefined;
    const goToLast = data && currentPagination.page < data.meta.totalPages ? ()=>setCurrentPagination(data ? {
            page: data.meta.totalPages
        } : {
            page: 1
        }, {
            shallow: true
        }) : undefined;
    const changeLimit = (limit)=>{
        return setCurrentPagination({
            page: 1,
            limit
        }, {
            shallow: true
        });
    };
    const changeSearch = (search)=>{
        return setCurrentPagination({
            page: 1,
            search
        }, {
            shallow: true
        });
    };
    return (0,react.useMemo)(()=>{
        return {
            ...query,
            pagination: {
                goToFirst,
                goToLast,
                goToNext,
                goToPrevious,
                goToPage,
                currentPage: currentPagination.page,
                currentLimit: currentPagination.limit,
                currentSearch: currentPagination.search,
                changeLimit,
                changeSearch,
                totalPages: (data === null || data === void 0 ? void 0 : data.meta.totalPages) || 0,
                totalItems: (data === null || data === void 0 ? void 0 : data.meta.totalItems) || 0
            }
        };
    }, [
        currentPagination,
        data
    ]);
}


/***/ }),

/***/ 77795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useScrollTo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const DEFAULT_SCROLL_TO = {
    yOffset: -80
};
function useScrollTo(props) {
    const scrollWrapper = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const scrollTo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_SCROLL_TO;
        if (!scrollWrapper.current) return;
        const y = scrollWrapper.current.getBoundingClientRect().top + window.pageYOffset + options.yOffset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    }, [
        props.id
    ]);
    const queryElement = ()=>{
        const element = document.querySelector("#".concat(props.id));
        if (!element) throw new Error("Scroll wrapper not found");
        return element;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        scrollWrapper.current = queryElement();
    }, []);
    return {
        element: scrollWrapper.current,
        scrollTo
    };
}


/***/ }),

/***/ 78897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ CheckBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const CheckBox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { text , description , className , disabled , labelClassName , htmlFor , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex items-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center h-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    ref: ref,
                    ...rest,
                    disabled: disabled,
                    type: "checkbox",
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-4 w-4 rounded", {
                        "text-primary-500 !ring-primary-600": !disabled,
                        "text-neutral-400 !ring-neutral-500": disabled
                    }, className)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "ml-3 text-sm",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : rest.name,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-sm", {
                            "text-gray-700": !disabled,
                            "text-neutral-500": disabled
                        }, labelClassName),
                        children: text
                    }),
                    description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                            "text-gray-500": !disabled,
                            "text-gray-300": disabled
                        }),
                        children: description
                    }) : null
                ]
            })
        ]
    });
});


/***/ }),

/***/ 43403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const Text = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { className , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
        ref: ref,
        type: "text",
        ...rest,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("block w-full shadow-sm focus:ring-primary-100 focus:border-primary-500 text-sm border-neutral-200 rounded-xl placeholder:text-neutral-500 placeholder:font-light", className)
    });
});


/***/ }),

/***/ 14927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ItemsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function ItemsList(param) {
    let { items , renderItem , className , liClassName , noItemsMessage ="Not found" , noItemsClassName  } = param;
    if (items.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("font-medium text-sm text-neutral-900 my-5 text-center block", noItemsClassName),
            children: noItemsMessage
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className),
        children: items.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full", liClassName),
                children: renderItem(item)
            }, item.id))
    });
}


/***/ }),

/***/ 4015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57100);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7595);





const Pagination = (props)=>{
    const { goToFirst , goToLast , goToNext , goToPrevious , totalPages , currentPage  } = props.pagination;
    const onPageChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((cb)=>{
        var ref;
        cb === null || cb === void 0 ? void 0 : cb();
        (ref = props.onPageChange) === null || ref === void 0 ? void 0 : ref.call(props);
    }, [
        props.onPageChange
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-1",
        id: "pagination",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                variant: "base",
                disabled: !goToPrevious,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-10 w-10 !px-3"),
                onClick: ()=>onPageChange(goToPrevious),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_4__/* .ChevronLeft */ .s, {
                    className: "w-4 h-4"
                })
            }),
            currentPage !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                variant: "base",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-10 w-10 !px-3 !text-xs"),
                disabled: !goToFirst,
                onClick: ()=>onPageChange(goToFirst),
                children: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                variant: "outline",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-10 w-10 !px-3 !text-xs"),
                children: currentPage
            }),
            currentPage !== totalPages && totalPages !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                variant: "base",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-10 w-10 !px-3 !text-xs"),
                disabled: !goToLast,
                onClick: ()=>onPageChange(goToLast),
                children: totalPages
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                variant: "base",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-10 w-10 !px-3"),
                disabled: !goToNext,
                onClick: ()=>onPageChange(goToNext),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_4__/* .ChevronLeft */ .s, {
                    className: "rotate-180 w-4 h-4"
                })
            })
        ]
    });
};


/***/ }),

/***/ 70996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ InsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const InsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className , id  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-6 w-full max-w-6xl mx-auto", className),
        id: id,
        children: children
    });
};


/***/ }),

/***/ 55368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OutsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const OutsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-4 w-full max-w-screen-2xl mx-auto md:p-[30px] lg:p-10", className),
        children: children
    });
};


/***/ }),

/***/ 71740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ArrowRight = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        className: className,
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17 8L21 12M21 12L17 16M21 12H3",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 7595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ChevronLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ChevronLeft = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5182 11.9998L15.6582 17.2468C16.0743 17.6108 16.1163 18.2428 15.7522 18.6578C15.3882 19.0738 14.7563 19.1158 14.3413 18.7528L8.34125 12.7518C7.88625 12.3538 7.88625 11.6458 8.34125 11.2478L14.3413 5.24782C14.7563 4.88382 15.3882 4.92582 15.7522 5.34082C16.1163 5.75682 16.0743 6.38882 15.6582 6.75182L10.5182 11.9998Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_712_11636",
                    x1: "8",
                    y1: "6.68962",
                    x2: "16.8537",
                    y2: "7.59025",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "#2CBC32"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.98762",
                            stopColor: "#07996E"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 98427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ChevronRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ChevronRight = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9 5L16 12L9 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 71023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const CloseIcon = (param)=>/*#__PURE__*/ {
    let { className , strokeWidth =2  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.5 1.5L1.5 8.5",
                stroke: "currentColor",
                strokeWidth: "".concat(strokeWidth),
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.5 1.5L8.5 8.5",
                stroke: "currentColor",
                strokeWidth: "".concat(strokeWidth),
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5620,9531,9774,2888,179], function() { return __webpack_exec__(23244); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);